import PropTypes from 'prop-types';

export const propTypes = {
  className: PropTypes.string,
  data: PropTypes.array,
  disabled: PropTypes.bool,
  eventName: PropTypes.string,
  hideLabel: PropTypes.bool,
  input: PropTypes.object,
  icon: PropTypes.string,
  inputProps: PropTypes.object,
  onChange: PropTypes.func,
  search: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export const defaultProps = {
  className: '',
  data: [],
  disabled: false,
  eventName: 'select_change',
  hideLabel: false,
  icon: '',
  input: {},
  inputProps: {},
  onChange: () => {},
  search: '',
  value: '',
};
